// Issue #296 — sending the transport order claims the IRM for its sender.
//
// Policy (agreed 2026-08-19):
//   • only employees carrying the `logistics` role become the assignee;
//   • the field is filled ONLY when empty — an existing assignment (manual or
//     from an earlier send) is never silently replaced, so a colleague's resend
//     cannot steal the transaction.

import type { EmployeeDao } from '../employee/EmployeeDao.ts';
import type { TransactionDao } from './TransactionDao.ts';

export type TransportOrderAssignmentOutcome =
  | 'assigned'
  | 'no_employee'
  | 'not_logistics'
  | 'already_assigned';

export async function assignLogisticianOnTransportOrder(
  deps: { employees: EmployeeDao; transactions: TransactionDao },
  transactionId: number,
  senderUserId: string,
): Promise<TransportOrderAssignmentOutcome> {
  const employee = await deps.employees.getByUserId(senderUserId);
  if (!employee) return 'no_employee';
  if (!employee.roles.includes('logistics')) return 'not_logistics';

  const assigned = await deps.transactions.assignLogisticianIfUnassigned(transactionId, employee.id);
  return assigned ? 'assigned' : 'already_assigned';
}
